import { createContext } from "react";

export type CaseAnalysisContextType = {
  case_id: string | number;
};

export const CaseAnalysisContext = createContext<CaseAnalysisContextType>({
  case_id: "",
});

export const CaseAnalysisProvider: React.FC<
  {
    children: React.ReactNode;
  } & CaseAnalysisContextType
> = ({ children, case_id }) => {
  return (
    <CaseAnalysisContext.Provider
      value={{
        case_id,
      }}
    >
      {children}
    </CaseAnalysisContext.Provider>
  );
};
